export default "__VITE_ASSET__D6XltsjG__"